import React from "react";
import ReactDOM from "react-dom";
import ScheduledAcquisitionDetailReact from "./ScheduledAcquisitionDetail";

class ScheduledAcquisitionDetail extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.innerHTML = `<div id="root"></div>`;

    ReactDOM.render(
      React.createElement(ScheduledAcquisitionDetailReact, {
        reportData: JSON.parse(this.getAttribute("report_data")),
        domainSettings: JSON.parse(this.getAttribute("domain_settings")),
        locationNames: JSON.parse(this.getAttribute("location_names")),
        groupNames: JSON.parse(this.getAttribute("group_names")),
      }),
      this.querySelector("#root")
    );
  }
}

customElements.define("scheduled-acquisition-detail", ScheduledAcquisitionDetail);
